(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card.bought-together"] && !Shopify.designMode) return;
  try {
    new Swiper('.bought-together-mobile', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 12,
    pagination: {
      el: '.bought-together-mobile .swiper-pagination',
      clickable: true,
    },
    watchOverflow: true,
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charger-space"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.charger-space__card-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.charger-space__card')
        const isActive = card.classList.toggle('active')
        btn.setAttribute('aria-label', isActive ? 'Hide details' : 'Show details')
      })
    })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    const popup = document.getElementById('newsletter-popup')
  const closePopup = document.getElementById('close-newsletter-popup')

  closePopup.addEventListener('click', () => {
    popup.style.display = 'none'
    document.body.style.overflow = 'auto'
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-delivery-time"] && !Shopify.designMode) return;
  try {
    function getNext5pmUTC() {
    const now = new Date()
    let target = new Date(now)
    target.setUTCHours(17, 0, 0, 0)
    if (now.getUTCHours() >= 17) {
      target.setUTCDate(target.getUTCDate() + 1)
    }
    return target
  }
  function updateTimer() {
    const now = new Date()
    const target = getNext5pmUTC()
    const diff = target.getTime() - now.getTime()
    if (diff <= 0) {
      document.getElementById('delivery-timer').textContent = '00:00:00'
      return
    }
    const hours = Math.floor((diff / 3600000) % 3)
    const minutes = Math.floor((diff % 3600000) / 60000)
    const seconds = Math.floor((diff % 60000) / 1000)
    document.getElementById('delivery-timer').textContent = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }
  setInterval(updateTimer, 1000)
  updateTimer()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var mapEl = document.querySelector('[data-variant-gallery-map]')
    if (!mapEl) return

    var data = JSON.parse(mapEl.textContent)
    var variants = data.variants
    var slider = document.querySelector('#product-slider')
    var sliderComponent = document.querySelector('slider-component')
    var thumbContainer = document.querySelector('slider-thumbnails')
    if (!slider || !sliderComponent) return

    /* ── Helpers ─────────────────────────────────────────── */

    function reindexSlides() {
      var slides = slider.querySelectorAll('.slider-slide')
      var bullets = thumbContainer
        ? thumbContainer.querySelectorAll('.slider-media-bullet')
        : []
      slides.forEach(function (s, i) {
        s.setAttribute('data-index', String(i))
      })
      bullets.forEach(function (b, i) {
        b.setAttribute('data-index', String(i))
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1))
      })
    }

    /* dark_navbar = light image, so the slide reads as a light section */
    function colorScheme(entry) {
      return entry.dark_navbar ? 'light' : 'dark'
    }

    /* Let the navbar (assets/sticky-header.js) track the variant slide's scheme */
    function watchSlide(slide) {
      var header = document.querySelector('sticky-header')
      if (header && header.observeProductSlide) header.observeProductSlide(slide)
    }

    function unwatchSlide(slide) {
      var header = document.querySelector('sticky-header')
      if (header && header.unobserveProductSlide) header.unobserveProductSlide(slide)
    }

    function buildVariantSlide(entry) {
      var slide = document.createElement('div')
      slide.className = 'slider-slide'
      slide.setAttribute('role', 'listitem')
      slide.setAttribute('data-variant-slide', '')
      slide.setAttribute('data-color-scheme', colorScheme(entry))

      var picture = document.createElement('picture')
      picture.className = 'slider-media__picture'

      if (entry.mobile_1x) {
        var tabletSrc = document.createElement('source')
        tabletSrc.setAttribute('media', '(min-width: 1024px) and (max-width: 1299px)')
        tabletSrc.setAttribute('srcset', entry.mobile_2x + ' 1x, ' + entry.mobile_2x + ' 2x')
        tabletSrc.setAttribute('width', '1400')
        tabletSrc.setAttribute('height', '2488')
        picture.appendChild(tabletSrc)

        var mobileSrc = document.createElement('source')
        mobileSrc.setAttribute('media', '(max-width: 550px)')
        mobileSrc.setAttribute('srcset', entry.mobile_1x + ' 1x, ' + entry.mobile_2x + ' 2x')
        mobileSrc.setAttribute('width', '1080')
        mobileSrc.setAttribute('height', '1920')
        picture.appendChild(mobileSrc)
      }

      var desktopSrc = document.createElement('source')
      desktopSrc.setAttribute('media', '(min-width: 550px)')
      desktopSrc.setAttribute('srcset', entry.desktop_1x + ' 1x, ' + entry.desktop_2x + ' 2x')
      desktopSrc.setAttribute('width', '1920')
      desktopSrc.setAttribute('height', '1080')
      picture.appendChild(desktopSrc)

      var img = document.createElement('img')
      img.setAttribute('src', entry.desktop_1x)
      img.setAttribute('alt', entry.alt || '')
      img.setAttribute('loading', 'eager')
      img.setAttribute('fetchpriority', 'high')
      picture.appendChild(img)

      slide.appendChild(picture)
      return slide
    }

    function buildVariantBullet() {
      var btn = document.createElement('button')
      btn.className = 'slider-media-bullet'
      btn.setAttribute('role', 'tab')
      btn.setAttribute('aria-selected', 'true')
      btn.setAttribute('aria-controls', 'product-slider')
      btn.setAttribute('data-variant-bullet', '')
      return btn
    }

    /* ── Update sources on an existing variant slide ───── */

    function updateVariantSources(slide, entry) {
      var picture = slide.querySelector('.slider-media__picture')
      var sources = picture.querySelectorAll('source')
      var img = picture.querySelector('img')

      sources.forEach(function (source) {
        var media = source.getAttribute('media') || ''
        if (media.indexOf('max-width: 550px') !== -1 && entry.mobile_1x) {
          source.setAttribute('srcset', entry.mobile_1x + ' 1x, ' + entry.mobile_2x + ' 2x')
        } else if (media.indexOf('min-width: 1024px') !== -1 && media.indexOf('max-width: 1299px') !== -1 && entry.mobile_1x) {
          source.setAttribute('srcset', entry.mobile_2x + ' 1x, ' + entry.mobile_2x + ' 2x')
        } else if (media.indexOf('min-width: 550px') !== -1) {
          source.setAttribute('srcset', entry.desktop_1x + ' 1x, ' + entry.desktop_2x + ' 2x')
        }
      })

      if (img) {
        img.setAttribute('src', entry.desktop_1x)
        img.setAttribute('alt', entry.alt || '')
      }
    }

    /* ── Main swap logic ───────────────────────────────── */

    function swapSlide(variantId) {
      var entry = variants[variantId]
      var existing = slider.querySelector('[data-variant-slide]')
      var existingBullet = thumbContainer
        ? thumbContainer.querySelector('[data-variant-bullet]')
        : null

      if (!entry) {
        /* No override — remove the variant slide if present */
        if (existing) {
          unwatchSlide(existing)
          existing.remove()
          if (existingBullet) existingBullet.remove()
          reindexSlides()
          if (sliderComponent.refresh) sliderComponent.refresh()
        }
        return
      }

      if (existing) {
        /* Variant slide already in DOM — just update its images */
        updateVariantSources(existing, entry)
        existing.setAttribute('data-color-scheme', colorScheme(entry))
        watchSlide(existing)
      } else {
        /* Create and prepend a new variant slide */
        var overlay = slider.querySelector('[data-gallery-overlay]')
        var newSlide = buildVariantSlide(entry)
        if (overlay && overlay.nextSibling) {
          slider.insertBefore(newSlide, overlay.nextSibling)
        } else {
          slider.prepend(newSlide)
        }
        watchSlide(newSlide)

        if (thumbContainer) {
          thumbContainer.prepend(buildVariantBullet())
        }

        reindexSlides()
        if (sliderComponent.refresh) sliderComponent.refresh()
      }
    }

    /* ── Scroll to first slide ─────────────────────────── */

    function scrollToFirst() {
      if (slider && slider.scrollLeft > 0) {
        slider.scrollTo({ left: 0, behavior: 'smooth' })
      }
    }

    /* ── Event listeners ───────────────────────────────── */

    document.addEventListener('variant:changed', function (e) {
      var variantId = e.detail && e.detail.variantId
      if (variantId) {
        swapSlide(String(variantId))
        scrollToFirst()
      }
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-question-1"] && !Shopify.designMode) return;
  try {
    const swiper = new Swiper('.quiz-question-feeling-container', {
    loop: false,
    spaceBetween: 24,
    breakpoints: {
      1: {
        slidesPerView: 1.4,
        spaceBetween: 35,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-custom-button-next',
      prevEl: '.swiper-custom-button-prev',
    },
  })
  const question1 = document.getElementById('quiz-question-1')
  const thisNextButton = question1.querySelectorAll('#next-btn')
  const inputs = question1.querySelectorAll('.quiz-question-feeling-input')
  inputs.forEach((input, index) => {
    input.addEventListener('click', () => {
      inputs.forEach((inp) => inp.classList.remove('selected'))
      setAnswer(1, index, input)
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-question-2"] && !Shopify.designMode) return;
  try {
    const question2 = document.getElementById('quiz-question-2')
  const deselectButtons = question2.querySelectorAll('.quiz-question-improve-deselect')
  const inputs = question2.querySelectorAll('.quiz-question-improve-input')
  function clearBubbleClasses() {
    inputs.forEach((input) => {
      input.classList.remove('selected')
      input.classList.remove('not-selected-1')
      input.classList.remove('not-selected-2')
      input.classList.remove('not-selected-3')
    })
  }
  function selectBubble(index) {
    clearBubbleClasses()
    setAnswer(2, index, inputs[index])

    let counter = 0
    inputs.forEach((input) => {
      if (input.classList.contains('selected')) {
      } else {
        counter++
        input.classList.add('not-selected-' + counter)
      }
    })
  }
  inputs.forEach((input, index) => {
    input.addEventListener('click', () => selectBubble(index))
  })
  deselectButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation()
      clearBubbleClasses()
      setAnswer(2, null, null)
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-question-3"] && !Shopify.designMode) return;
  try {
    const question3 = document.getElementById('quiz-question-3')
  const thisNextButton = question3.querySelectorAll('#next-btn')
  const inputs = question3.querySelectorAll('.quiz-question-hands-input')
  inputs.forEach((input, index) => {
    input.addEventListener('click', () => {
      inputs.forEach((inp) => inp.classList.remove('selected'))
      setAnswer(3, index, input)
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-question-4"] && !Shopify.designMode) return;
  try {
    const backSlideBtn = document.getElementById('slide-back')
  const nextSlideBtn = document.getElementById('slide-next')
  const slides = document.querySelectorAll('.quiz-question-win-input')
  let current = 1

  function nextSlide() {
    slides[current].classList.remove('current')
    slides[current].classList.add('prev')
    current++
    if (current >= slides.length) {
      current = 0
    }
    slides[current].classList.remove('next')
    slides[current].classList.add('current')
    setAnswer(4, current, slides[current])
    const nextIndex = current + 1 >= slides.length ? 0 : current + 1
    slides[nextIndex].classList.remove('prev')
    slides[nextIndex].classList.add('next')
  }
  function prevSlide() {
    slides[current].classList.remove('current')
    slides[current].classList.add('next')
    current--
    if (current < 0) {
      current = slides.length - 1
    }
    slides[current].classList.remove('prev')
    slides[current].classList.add('current')
    setAnswer(4, current, slides[current])
    const prevIndex = current - 1 < 0 ? slides.length - 1 : current - 1
    slides[prevIndex].classList.remove('next')
    slides[prevIndex].classList.add('prev')
  }

  backSlideBtn.addEventListener('click', () => {
    prevSlide()
  })
  nextSlideBtn.addEventListener('click', () => {
    nextSlide()
  })

  const question4 = document.getElementById('quiz-question-4')

  const carousel = question4.querySelector('.quiz-question-win-inputs')
  let startX = 0
  let isDragging = false

  carousel.addEventListener('mousedown', (e) => {
    isDragging = true
    startX = e.clientX
  })
  carousel.addEventListener('mouseup', (e) => {
    if (!isDragging) return
    isDragging = false
    const endX = e.clientX
    if (endX < startX - 30) nextSlide()
    else if (endX > startX + 30) prevSlide()
  })

  // Touch events
  carousel.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX
  })
  carousel.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX
    if (endX < startX - 30) nextSlide()
    else if (endX > startX + 30) prevSlide()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-start"] && !Shopify.designMode) return;
  try {
    const initSection = document.getElementById('quiz-start-init')
  const emailSection = document.getElementById('quiz-start-email')
  function showEmailSection() {
    initSection.style.display = 'none'
    emailSection.style.display = 'block'
  }
  initSection.addEventListener('click', showEmailSection)

  const emailInput = document.getElementById('quiz-email')
  const submitBtn = document.getElementById('quiz-submit')

  document.getElementById('quiz-start-email').addEventListener('submit', function (e) {
    e.preventDefault()
    quiz.email = emailInput.value
    localStorage.setItem('quiz', JSON.stringify(quiz))

    nextStep()
  })

  emailInput.addEventListener('blur', () => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-learn-more-info"] && !Shopify.designMode) return;
  try {
    const createOdometer = (element, value) => {
    const od = new Odometer({
      el: element,
      value: 0,
      animation: 'count',
      duration: 1000,
      format: 'ddd',
    })
    // Only update when visible
    const observer = new window.IntersectionObserver(
      function (entries, obs) {
        if (entries[0].isIntersecting) {
          setTimeout(() => {
            od.update(value)
          }, 200)

          obs.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(element)
  }
  const odometer = document.getElementById('v2-learn-more-odometer-freq')

  createOdometer(odometer, odometer.dataset.freq)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-learn-more-mobius-coil"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.v2-learn-more-mobius-coil-background video').forEach(function (video) {
    video.muted = true
    video.play().catch(function () {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {})
            obs.disconnect()
          }
        })
      })
      observer.observe(video)
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["water-bottle-crystals"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.water-bottle-crystals__card-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.water-bottle-crystals__card')
        const isActive = card.classList.toggle('active')
        btn.setAttribute('aria-label', isActive ? 'Hide details' : 'Show details')
      })
    })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["why-schumann-community"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-wsp-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-wsp-carousel-track]');
      var prev = root.querySelector('[data-wsp-carousel-step="-1"]');
      var next = root.querySelector('[data-wsp-carousel-step="1"]');
      if (!track) return;
      var index = 0;

      function step() {
        var card = track.children[0];
        return card ? card.getBoundingClientRect().width + 12 : 0;
      }
      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }
      function maxIndex() {
        var s = step();
        return s ? Math.ceil((maxScroll() - 1) / s) : 0;
      }
      function render() {
        var max = maxIndex();
        index = Math.min(index, max);
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index >= max;
      }
      function go(i) {
        index = Math.max(0, Math.min(maxIndex(), i));
        track.scrollTo({ left: Math.min(step() * index, maxScroll()), behavior: 'smooth' });
        render();
      }

      root.querySelectorAll('[data-wsp-carousel-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          go(index + parseInt(btn.getAttribute('data-wsp-carousel-step'), 10));
        });
      });
      track.addEventListener(
        'scroll',
        function () {
          var s = step();
          if (!s) return;
          var max = maxIndex();
          var i = track.scrollLeft >= maxScroll() - 1 ? max : Math.max(0, Math.min(max, Math.round(track.scrollLeft / s)));
          if (i !== index) {
            index = i;
            render();
          }
        },
        { passive: true }
      );
      window.addEventListener('resize', render);
      render();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["why-schumann-environment"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var CAPTIONS = {
      day: 'Desk, second coffee, the long document.',
      night: 'Lamp on, laptop shut, the book you keep meaning to finish.',
    }
    document.querySelectorAll('[data-wsp-room]').forEach(function (root) {
      var caption = root.querySelector('[data-wsp-room-caption]')
      var buttons = root.querySelectorAll('[data-wsp-room-set]')
      var toggle = root.querySelector('.wsp-env__toggle')
      var interacted = false
      var timer = null
      var observer = null

      function set(tod) {
        root.classList.toggle('is-night', tod === 'night')
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-wsp-room-set') === tod))
        })
        if (caption) caption.textContent = CAPTIONS[tod]
      }

      function stopAuto() {
        clearTimeout(timer)
        if (observer) observer.disconnect()
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          interacted = true
          stopAuto()
          set(btn.getAttribute('data-wsp-room-set'))
        })
      })

      // Auto-toggle once if the toggle has been on screen for 1s without a click.
      if (toggle && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              timer = setTimeout(function () {
                if (interacted) return
                stopAuto()
                set(root.classList.contains('is-night') ? 'day' : 'night')
              }, 1000)
            } else {
              clearTimeout(timer)
            }
          },
          { threshold: 1 }
        )
        observer.observe(toggle)
      }
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["why-schumann-stats"] && !Shopify.designMode) return;
  try {
    ;(function () {
    // Count each stat number up from 0 the first time it scrolls fully into view.
    // Final values are server-rendered, so no-JS and reduced-motion visitors see them as-is.
    if (!('IntersectionObserver' in window)) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    var DURATION = 1600
    var fmt = new Intl.NumberFormat('en-US')

    function run(el) {
      var target = parseInt(el.getAttribute('data-wsp-count'), 10)
      var start = null
      function tick(now) {
        if (start === null) start = now
        var t = Math.min((now - start) / DURATION, 1)
        var eased = 1 - Math.pow(1 - t, 3)
        el.textContent = fmt.format(Math.round(target * eased))
        if (t < 1) requestAnimationFrame(tick)
      }
      requestAnimationFrame(tick)
    }

    // Each number starts on its own, so stacked mobile stats count as they're reached.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return
          observer.unobserve(entry.target)
          run(entry.target)
        })
      },
      { threshold: 1 }
    )
    document.querySelectorAll('[data-wsp-count]').forEach(function (el) {
      el.textContent = '0'
      observer.observe(el)
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["why-schumann-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var THRESHOLD = 500;
    document.querySelectorAll('[data-wsp-sticky]').forEach(function (el) {
      var ticking = false;
      function update() {
        ticking = false;
        el.classList.toggle('is-visible', window.scrollY >= THRESHOLD);
      }
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
          }
        },
        { passive: true }
      );
      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["why-schumann-technology"] && !Shopify.designMode) return;
  try {
    (function () {
    var EASE = 'transform 0.45s cubic-bezier(0.4,0,0.2,1)';

    document.querySelectorAll('[data-wsp-tech]').forEach(function (root) {
      var labels = root.querySelectorAll('[data-wsp-label]');
      var total = labels.length;
      var part = parseInt(root.getAttribute('data-active'), 10) || 0;
      var busy = false;

      function shift(dir) {
        if (busy || !total) return;
        busy = true;
        var prev = part;
        part = (part + dir + total) % total;

        var incoming = labels[part];
        var outgoing = labels[prev];
        incoming.style.transition = 'none';
        incoming.style.transform = 'translateX(' + dir * 100 + '%)';
        void incoming.offsetWidth;

        requestAnimationFrame(function () {
          incoming.style.transition = EASE;
          incoming.style.transform = 'translateX(0)';
          outgoing.style.transition = EASE;
          outgoing.style.transform = 'translateX(' + -dir * 100 + '%)';
          labels.forEach(function (l, i) {
            l.classList.toggle('is-active', i === part);
            if (i === part) l.removeAttribute('aria-hidden');
            else l.setAttribute('aria-hidden', 'true');
          });
          setTimeout(function () {
            busy = false;
          }, 450);
        });

        root.querySelectorAll('[data-wsp-part]').forEach(function (el) {
          el.classList.toggle('is-active', parseInt(el.getAttribute('data-wsp-part'), 10) === part);
        });
      }

      root.querySelectorAll('[data-wsp-tech-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          shift(parseInt(btn.getAttribute('data-wsp-tech-step'), 10));
        });
      });

      var wave = root.querySelector('[data-wsp-wave]');
      if (!wave) return;
      var NOTES = {
        sine: 'Sine. Smooth and continuous. A good default for winding down and overnight.',
        square: 'Square. Sharper and more pulsed. Many people prefer it for daytime focus.',
      };
      var note = wave.querySelector('[data-wsp-wave-note]');
      var waveButtons = wave.querySelectorAll('[data-wsp-wave-set]');
      waveButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var kind = btn.getAttribute('data-wsp-wave-set');
          wave.classList.toggle('is-square', kind === 'square');
          waveButtons.forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          if (note) note.textContent = NOTES[kind];
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
